import { BaseRepository } from "@/repositories/base-repository"
import { type IRentalDispenseItem } from "@/interfaces/api/rental-dispense-item.interface"

export class RentalDispenseItemRepository extends BaseRepository<IRentalDispenseItem> {
  protected resourcePath = "administration/rental-dispense-items"
}
